var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upload-img-box" }, [
    _vm.file
      ? _c("dl", { staticClass: "img-item" }, [
          _c("dt", [
            _c("img", {
              staticClass: "skin",
              attrs: { src: _vm.getUrl(_vm.currentFile), alt: "" },
            }),
          ]),
          _c("dd", { staticClass: "img-close", on: { click: _vm.close } }, [
            _vm._v("x"),
          ]),
        ])
      : _c("dl", { staticClass: "add-img" }, [
          _c("dt", [
            _c("label", [
              _vm._v("+"),
              _c("input", {
                staticClass: "add_img_upload_btn",
                staticStyle: { display: "none" },
                attrs: { accept: ".png,.jpg,.gif", type: "file" },
                on: { change: _vm.changeFile },
              }),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }